import React from "react";
import AppHeaderView from "./view";

export default function AppHeader() {
  return <AppHeaderView />;
}
